import { Injectable, signal } from '@angular/core';
import type { FeatureFlagged, ServiceFeatureFlagKey, ServiceFeatureFlags } from '../models/feature-flag.model';
import {
  CONTACT_SITE_TYPE_FLAG_MAP,
  HERO_BADGE_FLAG_MAP,
  LAUNCH_FEATURE_FLAGS,
  TRUST_BAR_FLAG_MAP,
} from '../models/feature-flag.model';

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
  readonly flags = signal<ServiceFeatureFlags>({ ...LAUNCH_FEATURE_FLAGS });

  isEnabled(key: ServiceFeatureFlagKey): boolean {
    return this.flags()[key];
  }

  filterItems<T extends FeatureFlagged>(items: T[]): T[] {
    return items.filter(item => !item.flagKey || this.isEnabled(item.flagKey));
  }

  filterStrings(items: string[], mapping: Record<string, ServiceFeatureFlagKey>): string[] {
    return items.filter(item => {
      const flagKey = mapping[item];
      return !flagKey || this.isEnabled(flagKey);
    });
  }

  filterHeroBadges(badges: string[]): string[] {
    return this.filterStrings(badges, HERO_BADGE_FLAG_MAP);
  }

  filterTrustBarItems<T extends FeatureFlagged & { label: string }>(items: T[]): T[] {
    return items.filter(item => {
      const mappedKey = TRUST_BAR_FLAG_MAP[item.label];
      const flagKey = item.flagKey ?? mappedKey;
      return !flagKey || this.isEnabled(flagKey);
    });
  }

  filterContactSiteTypes<T extends { value: string }>(options: readonly T[]): T[] {
    return options.filter(option => {
      const flagKey = CONTACT_SITE_TYPE_FLAG_MAP[option.value];
      return !flagKey || this.isEnabled(flagKey);
    });
  }
}
